/**
 * Portal Manta · CelulaEdit
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { M, F, STATUS } from '../../tokens/theme.js';

const CelulaEdit = memo(function CelulaEdit_Inner({campo, valor, onChange}){
  const baseStl = {
    width:'100%', padding:'4px 6px', border:'1px solid transparent',
    fontFamily:F.body, fontSize:11.5, color:M.text, outline:'none', background:'transparent',
    borderRadius:2,
  };
  const focusStl = {
    border:`1px solid ${M.accent}`, background:'#fff',
  };
  const [foc, setFoc] = useState(false);
  const stl = {...baseStl, ...(foc ? focusStl : {})};

  if (campo.tipo === 'select') {
    return (<select value={valor || ''} onChange={e=>onChange(e.target.value)}
      onFocus={()=>setFoc(true)} onBlur={()=>setFoc(false)} style={stl}>
      <option value="">—</option>
      {(campo.opcoes || []).map(o => <option key={o} value={o}>{o}</option>)}
    </select>);
  }
  if (campo.tipo === 'textarea') {
    return (<input type="text" value={valor || ''} onChange={e=>onChange(e.target.value)}
      onFocus={()=>setFoc(true)} onBlur={()=>setFoc(false)} style={stl}
      placeholder={campo.placeholder || ''}/>);
  }
  if (campo.tipo === 'date') {
    return (<input type="date" value={valor || ''} onChange={e=>onChange(e.target.value)}
      onFocus={()=>setFoc(true)} onBlur={()=>setFoc(false)} style={stl}/>);
  }
  if (campo.tipo === 'number') {
    return (<input type="number" value={valor === 0 ? 0 : (valor || '')} onChange={e=>{
      const v = e.target.value;
      onChange(v === '' ? 0 : Number(v));
    }} onFocus={()=>setFoc(true)} onBlur={()=>setFoc(false)} style={{...stl, textAlign:'right'}}
      placeholder="0" min={campo.min} max={campo.max}
      step={campo.dec ? `0.${'0'.repeat(campo.dec-1)}1` : 1}/>);
  }
  return (<input type="text" value={valor || ''} onChange={e=>onChange(e.target.value)}
    onFocus={()=>setFoc(true)} onBlur={()=>setFoc(false)} style={stl}
    placeholder={campo.placeholder || ''}/>);
});

export { CelulaEdit };
export default CelulaEdit;
